module.exports = __webpack_public_path__ + "img/hyundai.16cbf09c.svg";